<template>
  <!-- 规则弹窗 -->
  <div v-if="show==true" class="home-alert flex-column">
    <div class="home-alert-box rule">
      <p class="ruleTitle">活动规则</p>
      <div class="home-rule-wrap">
        <div class="home-rule-item" v-for="(rule,idx) in ruleText" :key="idx">{{rule}}</div>
      </div>
    </div>
    <img @click="closeModal(false)" class="ruleClose" src="../../static/images/alert_close.png" alt="">
  </div>

</template>
<script>
import Vue from "vue";
import { Popup } from "vant";
Vue.use(Popup);
export default {
  name: "RulePopup",
  props: ["show","ruleText"],
  data() {
    // let test = [];
    // test.push(
    //   "111111111111111l进口量李开复思考发你了时间浪费了时间浪费市南山龙口粉丝副书记分类"
    // );
    // test.push("222222222222222");
    // test.push("333333333333333");
    return {
      // ruleText: test
    };
  },
  mounted() {
    // console.warn("ssljkljsl" + this.ruleText);
  },
  methods: {
    //子组件 向父组件传值。
    closeModal(statu) {
      this.$emit("closeRule",statu);
    }
  }
};
</script>

<style scoped lang="scss" src="../../static/scss/rulepopup.scss"></style>
<style scoped lang="scss" src="../../static/scss/base.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
